import { rgba } from 'polished'
import React from 'react'
import styled from 'styled-components'

import { FlightType } from '../../../../flightStatus/src/flightDetailsMapper.js'

export const ToggleButton = styled.button`
  flex: 1 0 50%;
  text-align: center;
  outline: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  ${({ theme }) => theme.borderRadius(1)};
  border: none;
  padding: 3px 8px;
  cursor: pointer;

  &:focus-visible {
    outline: 1px solid blue;
    outline-offset: 2px;
  }

  color: ${({ theme }) => theme.colors.widgetIconFill};
  background-color: ${({ theme }) => rgba(theme.colors.widgetText, 0.1)};

  ${({ active, theme }) => active
  ? `background-color: ${theme.colors.widgetIconFill};
       color: ${theme.colors.widgetBackground};`
  : null
}
`

export const Toggle = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  user-select: none;
`

// todo generalize with routeTypeControl from getDirections
export const FlightTypeToggle = ({ currentFlightType, onFlightTypeClicked, className, T }) => {
  const flightTypeButton = (flightType, text) => (
    <ToggleButton
      data-cy="FlightTypeToggle"
      active={currentFlightType === flightType}
      onClick={() => onFlightTypeClicked(flightType)}
      aria-pressed={currentFlightType === flightType}
    >
      {text}
    </ToggleButton>
  )

  return <Toggle className={className}>
    {flightTypeButton(FlightType.DEPARTURE, T('flightDetails:Departures'))}
    {flightTypeButton(FlightType.ARRIVAL, T('flightDetails:Arrivals'))}
  </Toggle>
}
